export enum EFavoritePageType {
  Offer = 'offer',
  Newbuilding = 'newbuilding',
  Houses = 'houses',
  Savedsearch = 'savedsearch',
}
